import {RestApiService} from '../../../../rest-api.service';
import {Observable} from 'rxjs';
import {ApiV0Administration} from '../../api.v0.administration';
import {AppConfig} from '../../../../../contracts/v0/administration/server.environment';
import {ADatabaseBackupRes} from '../../../../../contracts/v0/administration/database.contracts';
import {BaseCollectionModel} from '@yasc/yasc-material-components';


export class ApiV0Server {
    segment = '/Server';


    constructor(
        v0: ApiV0Administration,
        private rest: RestApiService,
    ) {
        this.segment = v0.segment + this.segment;
    }

    getEnvironment(): Observable<AppConfig> {
        return this.rest.get<AppConfig>(`${this.segment}/env`, AppConfig);
    }

    backupDatabase(): Observable<ADatabaseBackupRes> {
        return this.rest.post<{}, ADatabaseBackupRes>(`${this.segment}/db/backup`, ADatabaseBackupRes, {});
    }

    searchDatabaseBackups(): Observable<BaseCollectionModel<ADatabaseBackupRes>> {
        return this.rest.post<{}, BaseCollectionModel<ADatabaseBackupRes>>(
            `${this.segment}/db/backup/search`,
            ADatabaseBackupRes,
            {}
        );
    }

}